<template>
    <div class="leadingPost">
        <div class="text">
            <Heading
                :h="2"
                size="l">
                {{ title }}
            </Heading>
            <Contributor
                :slug="post.author.slug"
                :avatar="post.author.avatar"
                :name="post.author.name"
                :uploadTime="post.uploadTime">
                {{ siteContent.publishedBy }}
            </Contributor>

            <p class="summary">
                {{ summary }}
            </p>
        </div>
    </div>
</template>

<script>
    import Contributor from '@/components/entry/Contributor'

    export default {
        name: 'LeadingPost',
        components: {
            Contributor
        },
        props: {
            post: {
                type: Object,
                required: true
            }
        },
        computed: {
            title() {
                if(this.preferences.language === 'hu' && this.post.title.hu) {
                    return this.post.title.hu
                } else {
                    return this.post.title.en
                }
            },
            summary() {
                if(this.preferences.language === 'hu' && this.post.summary.hu) {
                    return this.post.summary.hu
                } else {
                    return this.post.summary.en
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../scss/variables';

    .text {
        position: relative;
        text-shadow: 0 0 2rem rgba(0, 0, 0, 0.4);
    }

    .h2 {
        position: relative;
        margin: 0 0 1.5rem 0;
    }

    .summary {
        font-size: 1.075rem;
        margin: 1.5rem 0 1.5rem 0;
    }

    .read {
        position: relative;
    }
</style>